import { Injectable } from '@angular/core';
import { RequestsProvider } from '../../../providers/requests/requests';
import { ActivitesSaisies } from '../../../models/heures-saisies.model';
import { GaugeBarData } from '../../../design-system/gauge-bar/gauge-bar.component';
import { UserService } from '../../../providers/auth/user.service';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class HeuresSaisiesService {
  constructor(
    private userService: UserService,
    private requestsProvider: RequestsProvider
  ) {}

  chargerDonnesHeuresSaisies(dateDebut: string, dateFin: string): Promise<ActivitesSaisies> {
    const currentUser = this.userService.getCurrentUser();
    let filter = {
      idIntervenant: currentUser?.id,
      dateDebut: dateDebut,
      dateFin: dateFin,
    };

    return this.requestsProvider.post(environment.apis.API_DACTECH_BACK_V1 + '/dureesActivitesSaisies', filter);
  }

  mapToGaugeData(dataHeuresSaisies: ActivitesSaisies): GaugeBarData[] {
    let gaugeData: GaugeBarData[] = [];
    if (!dataHeuresSaisies.temps_saisi) {
      return gaugeData;
    }
    let tempsSaisisMap: Map<string, number> = new Map(Object.entries(dataHeuresSaisies.temps_saisi));
    const typeActivitesMinutes = this.mapActivites(tempsSaisisMap);

    for (let typeActivite in typeActivitesMinutes) {
      gaugeData.push({
        name: this.getNameByTypeActite(typeActivite),
        color: this.getColorByTypeActivite(typeActivite),
        minutes: typeActivitesMinutes[typeActivite],
      });
    }
    return gaugeData;
  }

  private mapActivites(tempsSaisisMap: Map<string, number>) {
    const typeActivitesMinutes = {};
    tempsSaisisMap.forEach((valeur: number, key: string) => {
      let label = key;
      if (label === 'GESTION' || label === 'INTERNE') {
        label = 'other';
      }
      if (typeActivitesMinutes[label]) {
        typeActivitesMinutes[label] += valeur;
      } else {
        typeActivitesMinutes[label] = valeur;
      }
    });
    return typeActivitesMinutes;
  }

  getNameByTypeActite(typeActivite: string): string {
    const name = {
      CORRECTIF: 'TIME_COUNTER.GAUGE_BAR.TYPE_ACTIVITE.CORRECTIF',
      PREVENTIF: 'TIME_COUNTER.GAUGE_BAR.TYPE_ACTIVITE.PREVENTIF',
      INTERVENTION: 'TIME_COUNTER.GAUGE_BAR.TYPE_ACTIVITE.INTERVENTION',
      TRAVAUX: 'TIME_COUNTER.GAUGE_BAR.TYPE_ACTIVITE.TRAVAUX',
      CONDUITE: 'TIME_COUNTER.GAUGE_BAR.TYPE_ACTIVITE.CONDUITE',
      other: 'TIME_COUNTER.GAUGE_BAR.TYPE_ACTIVITE.OTHER',
    };
    return name[typeActivite] || '';
  }

  getColorByTypeActivite(typeActivite: string): string {
    const name = {
      CORRECTIF: '#EA322C',
      PREVENTIF: '#53A2F6',
      INTERVENTION: '#000000',
      TRAVAUX: '#C89D6B',
      CONDUITE: '#EE7C37',
      other: '#7351C5',
    };
    return name[typeActivite] || '';
  }
}
